import {
    ICharsItem,
    ICharsValuesCloth,
    IClothItem,
    ICreateClothItem,
    ICategory,
    IEditCloth,
    IModels, IStyle, IStyleFromPython, ITag
} from "../../../../types/index";
import s from './detailsView.module.css';
import React, {useEffect, useState, useCallback} from "react";
import {appAxiosInstance, clothesAxiosInstance, pythonBackAxiosInstance} from "../../../../api";
import {toast} from "react-toastify";
import {TagsBlock} from './TagsBlock/tagsBlock';
import {PhotoBlock} from './PhotoBlock/photoBlock';
import {ReactComponent as CopyIcon} from '../../../../assets/icons/copy-icon.svg';
import {ReactComponent as ShowIcon} from '../../../../assets/icons/show.svg';
import {useNavigate} from "react-router-dom";
import {Button, Form} from "react-bootstrap";

interface IClothesItemProps {
    clothId: string,
    isNew: boolean,
}

interface CharsCloth {
    charId: number;
    charValueId: number | null;
    charValueText: string;
    charName: string;
}

const LAYERS = [
    { name: "ABOVE_THE_WAIST_FIRST_LAYER", localizedName: "Плечевой первый слой" },
    { name: "ABOVE_THE_WAIST_SECOND_LAYER", localizedName: "Плечевой второй слой" },
    { name: "OUTERWEAR", localizedName: "Плечевые верхняя одежда" },
    { name: "PANTS", localizedName: "Поясные" },
    { name: "SHOES", localizedName: "Обувь" },
    { name: "BAG", localizedName: "Сумка" },
    { name: "ACCESSORIES", localizedName: "Аксессуары" }
];

export function DetailsView(
    {clothId, isNew}: IClothesItemProps
) {
    const navigate = useNavigate();

    const [newGender, setNewGender] = useState<string>('unisex');
    const [nameNewCloth, setNameNewCloth] = useState('');
    const [isNameNewClothCleared, setIsNameNewClothCleared] = useState(false);
    const [newManufacturer, setNewManufacturer] = useState('');
    const [isNewManufacturerCleared, setIsNewManufacturerCleared] = useState(false);
    const [stylistDescription, setStylistDescription] = useState('');
    const [newVendorCode, setNewVendorCode] = useState('');
    const [newCost, setNewCost] = useState('');
    const [isCostCleared, setIsCostCleared] = useState(false);
    const [isVendorCodeCleared, setIsVendorCodeCleared] = useState(false);
    const [newComposition, setNewComposition] = useState('');
    const [newDescription, setNewDescription] = useState('');
    const [isDescriptionCleared, setIsDescriptionCleared] = useState(false);
    const [newCategoryName, setNewCategoryName] = useState('');
    const [newDetailsUrl, setNewDetailsUrl] = useState('');
    const [isDetailsUrlCleared, setIsDetailsUrlCleared] = useState(false);
    const [showStyleModal, setShowStyleModal] = useState(false);
    const [availableAllStyles, setAvailableAllStyles] = useState<IStyleFromPython[]>([]);

    const [selectedLayers, setSelectedLayers] = useState<string[]>([]);
    const [isLayerDropdownOpen, setIsLayerDropdownOpen] = useState(false);

    const [newImages, setNewImages] = useState<string[]>([]);
    const [newColorCloth, setNewColorCloth] = useState('');
    const [isColorClothCleared, setIsColorClothCleared] = useState(false);

    const [searchTerm, setSearchTerm] = useState('');
    const [filteredStyles, setFilteredStyles] = useState<IStyleFromPython[]>([]);

    const [isStylesLoading, setIsStylesLoading] = useState(false);

    const [cloth, setCloth] = useState<IClothItem | undefined>(undefined);
    const [isClothLoading, setIsClothLoading] = useState(false);
    const [isCreatingCloth, setIsCreatingCloth] = useState(false);
    const [createdClothId, setCreatedClothId] = useState<string | null>(null);

    const [availableStyles, setAvailableStyles] = useState<IStyle[]>([]);

    const copyIdToClipboard = () => {
        const idToCopy = isNew ? (createdClothId || clothId) : `${clothId}`;
        navigator.clipboard.writeText(idToCopy)
            .then(() => {
                toast.success('ID скопирован в буфер обмена');
            })
            .catch(err => {
                toast.error('Не удалось скопировать ID');
            });
    };

    const handleTextareaChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
        setNewDescription(e.target.value);
        setIsDescriptionCleared(e.target.value === '');
    };

    const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value;
        setSearchTerm(value);

        if (value.trim() === '') {
            setFilteredStyles(availableAllStyles);
        } else {
            const filtered = availableAllStyles.filter(style =>
                style.name.toLowerCase().includes(value.toLowerCase().trim())
            );
            setFilteredStyles(filtered);
        }
    };

    const handleSearchClick = (e: React.MouseEvent<HTMLInputElement>) => {
        e.stopPropagation();
    };


    const toggleLayer = (layerName: string) => {
        setSelectedLayers(prev => {
            if (prev.includes(layerName)) {
                return prev.filter(l => l !== layerName);
            } else {
                return [...prev, layerName];
            }
        });
    };

    const getLayerLocalizedName = (layerName: string) => {
        const layer = LAYERS.find(l => l.name === layerName);
        return layer ? layer.localizedName : layerName;
    };

    const addingClothInStyle = async (styleId: number) => {
        try {
            await clothesAxiosInstance.post(`addingClothInStyle/${clothId}/${styleId}`);
            toast.success('Стиль успешно добавлен');
            setShowStyleModal(false);
            await getStyleByCloth();
        } catch (error) {
            toast.error('Ошибка при добавлении стиля');
        }
    };

    const getCloth = async () => {
        try {
            if (clothId === "-1") {
                return;
            }
            setIsStylesLoading(true);
            let apiUrl = `${clothId}`;

            const clothesListResponse = await clothesAxiosInstance.get<IClothItem>(apiUrl);
            const clothesResponse = clothesListResponse.data;

            if (clothesResponse != undefined) {
                setStylistDescription(clothesResponse.stylistDescription || '');
                setCloth(clothesResponse);
                if (clothesResponse.gender) {
                    setNewGender(clothesResponse.gender);
                } else if (clothesResponse.isWomenCloth !== undefined) {
                    setNewGender(clothesResponse.isWomenCloth === true ? 'female' :
                        clothesResponse.isWomenCloth === false ? 'male' : 'unisex');
                }

            } else {
                setCloth(undefined);
            }
        } catch (error) {
            setCloth(undefined);
            toast.error('Возникла ошибка при получении списка одежды');
        } finally {
            setIsStylesLoading(false);
        }
    }

    const getStyleByCloth = async () => {
        try {
            if (clothId === "-1") {
                return;
            }
            setIsClothLoading(true);

            const stylesListResponse = await clothesAxiosInstance.post<{ result: Record<string, IStyle[]> }>(
                `getStylesClothes`,
                [Number(clothId)]
            );

            const resultData = stylesListResponse.data;
            const stylesForCloth = resultData.result?.[clothId] || [];
            setAvailableStyles(stylesForCloth);

        } catch (error) {
            setAvailableStyles([]);
            toast.error('Возникла ошибка при получении доступных стилей');
        } finally {
            setIsClothLoading(false);
        }
    }

    const removeClothFromStyle = async (styleId: number) => {

        try {
            await clothesAxiosInstance.post(`removeClothFromStyle/${clothId}/${styleId}`);
            await getStyleByCloth();
        } catch (error) {
            toast.error("Ошибка удаления одежды из стиля")
        }
    }

    const handleGenderChange = (value: string) => {
        setNewGender(value);
        if (!isNew && cloth) {
            setCloth({
                ...cloth,
                gender: value
            });
        }
    };

    const handleCostChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setNewCost(e.target.value);
        setIsCostCleared(e.target.value === '');
    };

    const handleVendorCodeChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setNewVendorCode(e.target.value);
        setIsVendorCodeCleared(e.target.value === '');
    };

    const handleColorClothChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setNewColorCloth(e.target.value);
        setIsColorClothCleared(e.target.value === '');
    };

    const handleDescriptionChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setNewDescription(e.target.value);
        setIsDescriptionCleared(e.target.value === '');
    };

    const handleDetailsUrlChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setNewDetailsUrl(e.target.value);
        setIsDetailsUrlCleared(e.target.value === '');
    };

    const handleNameChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setNameNewCloth(e.target.value);
        setIsNameNewClothCleared(e.target.value === '');
    };

    const handleManufacturerChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setNewManufacturer(e.target.value);
        setIsNewManufacturerCleared(e.target.value === '');
    };

    const handleCompositionChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setNewComposition(e.target.value);
    };

    const hasRequiredFields = useCallback((): boolean => {
        return !!(
            nameNewCloth.trim() &&
            newVendorCode.trim() &&
            newColorCloth.trim() &&
            newManufacturer.trim() &&
            selectedLayers.length > 0
        );
    }, [nameNewCloth, newVendorCode, newColorCloth, newManufacturer, selectedLayers]);

    const getValidationErrors = useCallback((): string[] => {
        const errors: string[] = [];

        if (!nameNewCloth.trim()) {
            errors.push('название');
        }
        if (!newVendorCode.trim()) {
            errors.push('артикул');
        }
        if (!newColorCloth.trim()) {
            errors.push('цвет');
        }
        if (!newManufacturer.trim()) {
            errors.push('производитель');
        }
        if (selectedLayers.length === 0) {
            errors.push('слой');
        }

        return errors;
    }, [nameNewCloth, newVendorCode, newColorCloth, newManufacturer, selectedLayers]);

    const generateIdNewTag = () => {
        return Math.floor(Math.random() * -8) - 50;
    }

    const saveLayerTag = async (newClothId: string) => {
        const layers = selectedLayers;
        if (!layers || layers.length === 0) {
            return;
        }

        try {

            const layerValues = layers.map(layerName => {
                const layer = LAYERS.find(l => l.name === layerName);
                return layer ? layer.name : layerName;
            }).join(', ');

            const layerTag: CharsCloth = {
                charId: generateIdNewTag(),
                charValueId: null,
                charName: 'слой одежды',
                charValueText: layerValues
            };

            const response = await clothesAxiosInstance.post<boolean>(
                `editTag/${newClothId.toString()}`,
                layerTag
            );

            if (response.data) {
                toast.success('Слой одежды успешно добавлен');

            } else {
                toast.error('Ошибка при сохранении слоя одежды');
            }
        } catch (error) {
            toast.error('Ошибка при сохранении слоя одежды');
        }
    };

    const createCloth = async (): Promise<string | null> => {
        if (!hasRequiredFields()) {
            const errors = getValidationErrors();
            const errorMessage = `Заполните обязательные поля: ${errors.join(', ')}`;
            toast.error(errorMessage);
            return null;
        }

        const modelObject: IModels ={
            code: newColorCloth,
            photos: newImages
        }

        const requestDto: ICreateClothItem = {
            name: nameNewCloth,
            category: newCategoryName,
            cost: Number(newCost),
            vendorCode: newVendorCode,
            description: newDescription,
            url: newDetailsUrl,
            manufacturer: newManufacturer,
            gender: newGender,
            isWomenCloth: newGender === "female" ? true : newGender === "male" ? false : null,
            model: modelObject,
        };

        try {
            setIsCreatingCloth(true);
            const createClothResponse = await clothesAxiosInstance.post<number>(
                'createClothFromParsing',
                requestDto
            );

            if (createClothResponse.status === 200 || createClothResponse.status === 201) {
                const newClothId = createClothResponse.data.toString();
                setCreatedClothId(newClothId);
                toast.success('Модель одежды успешно создана');
                localStorage.setItem("layers", selectedLayers.toString());
                setTimeout(async () => {
                    await editCloth(newClothId);
                    saveLayerTag(newClothId)
                    navigate(`/details/${newClothId}`);
                }, 1000);


                return newClothId;
            }

            return null;
        } catch (error: any) {
            const errorMessage = error.response?.data?.message || 'Возникла ошибка при создании';
            toast.error(errorMessage);
            return null;
        } finally {
            setIsCreatingCloth(false);
        }
    };

    const getStyles = async () => {
        try {
            const response = await pythonBackAxiosInstance.get(`/v1/styles`, {
                headers: {
                    'Content-Type': 'application/json'
                }
            });
            const filteredStyles = response.data.filter((style: IStyle) => {
                if (newGender === 'unisex') {
                    return style.gender === 'unisex' || style.gender === 'male' || style.gender === 'female' || style.gender === null;
                }
                return style.gender === newGender || style.gender === null;
            });
            setAvailableAllStyles(filteredStyles);
        } catch (error) {
            toast.error('Ошибка при получении списка стилей');
            setAvailableAllStyles([]);
        }
    };

    useEffect(() => {
        getStyles();
    }, [newGender]);

    const editCloth = async (targetClothId?: string) => {
        const clothIdToEdit = targetClothId || createdClothId || clothId;

        if (!clothIdToEdit || clothIdToEdit === "-1") {
            toast.error('ID одежды не доступен для редактирования');
            return;
        }

        if (cloth) {
            cloth.stylistDescription = stylistDescription || '';
            cloth.gender = newGender;
        }

        const requestDto: IEditCloth = {
            name: nameNewCloth || null,
            manufacturer: newManufacturer || null,
            vendorCode: newVendorCode || null,
            colorCloth: newColorCloth || null,
            cost: Number(newCost) || null,
            description: newDescription || null,
            gender: newGender,
            detailsUrl: newDetailsUrl || null,
        };

        try {
            const editClothResponse = await clothesAxiosInstance.post<boolean>(
                `editClothInfo/${clothIdToEdit}`, requestDto
            );
            const response = editClothResponse.data;

            if (response) {
                toast.success('Изменения успешно сохранены');
                await getCloth();
            } else {
                toast.error('Возникла ошибка при сохранении изменений');
            }
        } catch (error) {
            toast.error('Возникла ошибка при сохранении изменений');
        }
    }

    const openStylePage = (styleId: number) => {
        if (!clothId) return '#';

        const adminBaseUrl = process.env.REACT_APP_TRENDS_ADMIN_PANEL_URL || '';

        const link= `${adminBaseUrl}${styleId}`;

        console.log(link);

        if (link && link !== '#') {
            window.open(link, '_blank', 'noopener,noreferrer');
        } else {
            toast.error('Ссылка на стиль недоступна');
        }
    }

    const showInClothesList = () => {
        const idToShow = isNew ? (createdClothId || clothId) : clothId;
        if (idToShow && idToShow !== "-1") {
            navigate('/?page=1', {
                state: {
                    searchId: idToShow
                }
            });
        } else {
            toast.error('ID одежды не доступен');
        }
    };

    const handleAddAction = async (action: (newClothId: string) => Promise<void>): Promise<void> => {
        if (isNew && !createdClothId) {
            const newClothId = await createCloth();
            if (newClothId) {
                setCreatedClothId(newClothId);
                await action(newClothId);
            }
        } else {
            await action(createdClothId || clothId);
        }
    };

    const handleSaveChanges = async () => {
        if (isNew) {
            await createCloth();
        } else {
            await editCloth();
        }
    }

    useEffect(() => {
        if (createdClothId && createdClothId !== "-1") {
            getCloth();
            getStyleByCloth();
        }
    }, [createdClothId]);

    useEffect(() => {
        if (!isNew) {
            getCloth();
            getStyleByCloth();
        } else {
            setSelectedLayers([]);
        }
    }, [clothId, isNew]);

    useEffect(() => {
        setFilteredStyles(availableAllStyles);
    }, [availableAllStyles]);

    return (
        <>
            <div className={s.detailsCloth}>
                <div className={s.modernProductHeader}>
                    <div className={s.modernProductTitle}>
                        <input
                            className={s.modernTitleInput}
                            type="text"
                            placeholder="Введите название модели одежды"
                            value={isNameNewClothCleared ? nameNewCloth : nameNewCloth || cloth?.name || ''}
                            onChange={handleNameChange}
                        />
                        <button
                            className={s.showBtn}
                            onClick={showInClothesList}
                            title="Показать одежду в списке"
                        >
                            <ShowIcon/>
                        </button>
                        <button
                            className={s.copyIdBtn}
                            onClick={copyIdToClipboard}
                            title="Копировать ID"
                        >
                            <CopyIcon/>
                        </button>
                        <button
                            className={s.modernSaveBtn}
                            onClick={handleSaveChanges}
                        >
                            {isCreatingCloth ? 'Создание...' : (isNew ? 'Создать модель одежды' : 'Сохранить изменения')}
                        </button>
                    </div>

                    <div className={s.modernInfoGrid}>
                        <div className={s.modernInfoItem}>
                            <label>Производитель</label>
                            <input
                                type="text"
                                placeholder="Введите производителя"
                                value={isNewManufacturerCleared ? newManufacturer : newManufacturer|| cloth?.manufacturer || ''}
                                onChange={handleManufacturerChange}
                            />
                        </div>

                        <div className={s.modernInfoItem}>
                            <label>Артикул</label>
                            <input
                                type="text"
                                placeholder="Введите артикул"
                                value={isVendorCodeCleared ? newVendorCode : newVendorCode || cloth?.vendorCode || ''}
                                onChange={handleVendorCodeChange}
                            />
                        </div>

                        <div className={s.modernInfoItem}>
                            <label>Стоимость</label>
                            <input
                                type="number"
                                placeholder="Введите стоимость"
                                value={isCostCleared ? newCost : newCost || cloth?.cost || ''}
                                onChange={handleCostChange}
                            />
                        </div>

                        <div className={s.modernInfoRow}>
                            {isNew && ( <div className={s.modernInfoItem}>
                                <label>Слой одежды</label>
                                {isNew ? (
                                    <div className={s.layerSelectorContainer}>
                                        <div
                                            className={`${s.layerSelectorTrigger} ${selectedLayers.length === 0 ? s.layerSelectorError : ''}`}
                                            onClick={() => setIsLayerDropdownOpen(!isLayerDropdownOpen)}
                                        >
                                            <div className={s.layerSelectorContent}>
                                                {selectedLayers.length > 0 ? (
                                                    <div className={s.selectedLayersWrapper}>
                                                        {selectedLayers.map(l => (
                                                            <span key={l} className={s.layerTag}>
                                    {getLayerLocalizedName(l)}
                                                                <span
                                                                    className={s.layerTagRemove}
                                                                    onClick={(e) => {
                                                                        e.stopPropagation();
                                                                        toggleLayer(l);
                                                                    }}
                                                                >
                                        ×
                                    </span>
                                </span>
                                                        ))}
                                                    </div>
                                                ) : (
                                                    <span className={s.placeholderText}>Выберите слой</span>
                                                )}
                                            </div>
                                            <span className={`${s.dropdownArrow} ${isLayerDropdownOpen ? s.dropdownArrowOpen : ''}`}>▼</span>
                                        </div>
                                        {isLayerDropdownOpen && (
                                            <div className={s.layerDropdown}>
                                                <div className={s.layerDropdownHeader}>
                                                    <span className={s.layerDropdownTitle}>Выберите слои</span>
                                                    <span className={s.layerDropdownCount}>
                            {selectedLayers.length} выбрано
                        </span>
                                                </div>
                                                {LAYERS.map((layer) => (
                                                    <div
                                                        key={layer.name}
                                                        className={`${s.layerOption} ${selectedLayers.includes(layer.name) ? s.layerOptionSelected : ''}`}
                                                        onClick={() => toggleLayer(layer.name)}
                                                    >
                                                        <div className={s.layerOptionCheckbox}>
                                                            {selectedLayers.includes(layer.name) && (
                                                                <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                                                                    <rect x="0.5" y="0.5" width="15" height="15" rx="3.5" fill="#6BC4D7" stroke="#6BC4D7"/>
                                                                    <path d="M4 8L7 11L12 5" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                                                </svg>
                                                            )}
                                                            {!selectedLayers.includes(layer.name) && (
                                                                <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                                                                    <rect x="0.5" y="0.5" width="15" height="15" rx="3.5" fill="white" stroke="#D1D5DB"/>
                                                                </svg>
                                                            )}
                                                        </div>
                                                        <span className={s.layerOptionLabel}>{layer.localizedName}</span>
                                                        {selectedLayers.includes(layer.name) && (
                                                            <span className={s.layerOptionCheckmark}>✓</span>
                                                        )}
                                                    </div>
                                                ))}
                                            </div>
                                        )}
                                    </div>
                                ) : (
                                    <div className={s.modernReadonlyValue}>
                                    </div>
                                )}
                            </div>)}

                            <div className={s.modernInfoItem}>
                                <label>Пол</label>
                                <select
                                    value={newGender}
                                    onChange={(e) => handleGenderChange(e.target.value)}
                                    className={s.modernSelect}
                                >
                                    <option value="unisex">Унисекс</option>
                                    <option value="female">Женский</option>
                                    <option value="male">Мужской</option>
                                </select>
                            </div>

                            <div className={s.modernInfoItem}>
                                <label>Цвет</label>
                                <input
                                    type="text"
                                    placeholder="Введите цвет"
                                    value={isColorClothCleared ? newColorCloth : newColorCloth|| cloth?.colorCloth || ''}
                                    onChange={handleColorClothChange}
                                />
                            </div>

                            <div className={s.modernInfoItem}>
                                <label
                                    onClick={() => window.open(newDetailsUrl || cloth?.detailsUrl, '_blank')}
                                    style={{cursor: (newDetailsUrl || cloth?.detailsUrl) ? 'pointer' : 'default'}}
                                >
                                    Ссылка на сайт
                                </label>
                                <div className={s.urlInputContainer}>
                                    <input
                                        type="text"
                                        placeholder="Введите ссылку на сайт производителя"
                                        value={isDetailsUrlCleared ? newDetailsUrl : newDetailsUrl || cloth?.detailsUrl || ''}
                                        onChange={handleDetailsUrlChange}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className={s.modernTopSectionsContainer}>
                    <div className={s.modernDescriptionSection}>

                        <div className={s.modernSectionHeader}>
                            <h3>Описание</h3>
                        </div>

                        <div className={s.modernFormGroup}>
                                    <textarea
                                        rows={4}
                                        value={isDescriptionCleared ? newDescription : newDescription || cloth?.description || ''}
                                        onChange={handleTextareaChange}
                                        placeholder="Описание товара..."
                                    />
                        </div>
                    </div>
                </div>

                <div className={s.modernTopSectionsContainer}>
                    <div className={s.modernDescriptionSection}>
                        <div className={s.line}>
                            <h4 className={s.availableStylesTitle}>Доступные стили:</h4>
                            <Button
                                className={s.modernBtnPrimary}
                                onClick={() => {
                                    getStyles();
                                    setShowStyleModal(true);
                                }}
                            >
                                + Добавить стиль
                            </Button>
                        </div>

                        <div className={s.availableStyles}>

                            {availableStyles.filter(style => style.autoFill === true).length > 0 && (
                                <div className={s.stylesCategory}>
                                    <div className={s.stylesCategoryHeader}>
                                        <span className={s.stylesCategoryBadge}>Автоматически рассчитанные</span>
                                    </div>
                                    <div className={s.positionsGrid}>
                                        {availableStyles
                                            .filter(style => style.autoFill === true)
                                            .map((style, index) => (
                                                <div
                                                    key={index}
                                                    className={`${s.positionItem} ${s.autoStyle}`}
                                                    onClick={() => openStylePage(style.styleId)}

                                                >
                                                    <span className={s.positionName}>{style.styleName}</span>
                                                    <span
                                                        className={s.deleteIcon}
                                                        onClick={(e) => {
                                                            e.stopPropagation();
                                                            removeClothFromStyle(style.styleId);
                                                        }}
                                                    >
                                                        ✕
                                                    </span>
                                                </div>
                                            ))}
                                    </div>
                                </div>
                            )}

                            {availableStyles.filter(style => style.autoFill === false).length > 0 && (
                                <div className={s.stylesCategory}>
                                    <div className={s.stylesCategoryHeader}>
                                        <span className={s.stylesCategoryBadge}>Проставленные стилистами</span>
                                    </div>
                                    <div className={s.positionsGrid}>
                                        {availableStyles
                                            .filter(style => style.autoFill === false)
                                            .map((style, index) => (
                                                <div
                                                    key={index}
                                                    className={`${s.positionItem} ${s.autoStyle}`}
                                                    onClick={() => openStylePage(style.styleId)}
                                                >
                                                    <span className={s.positionName}>{style.styleName}</span>
                                                    <span
                                                        className={s.deleteIcon}
                                                        onClick={(e) => {
                                                            e.stopPropagation();
                                                            removeClothFromStyle(style.styleId);
                                                        }}
                                                    >
                                                        ✕
                                                    </span>
                                                </div>
                                            ))}
                                    </div>
                                </div>
                            )}

                            {availableStyles.length === 0 && (
                                <div className={s.textEmptyBlock}>
                                    Нет доступных стилей
                                </div>
                            )}
                        </div>
                    </div>
                </div>

                <div className={s.modernContentGrid}>
                    <div className={s.modernLeftColumn}>
                        <div className={s.modernBottomSectionsContainer}>
                            <TagsBlock
                                clothId={isNew ? (createdClothId || clothId) : clothId}
                                isNew={isNew}
                                onAddAction={isNew ? handleAddAction : undefined}
                                hasRequiredFields={hasRequiredFields}
                            />
                        </div>
                    </div>

                    <div className={s.modernRightColumn}>
                        <div className={s.modernBottomSectionContainer}>
                            <PhotoBlock
                                cloth={cloth}
                                onClothUpdate={getCloth}
                                isNew={isNew}
                                onAddAction={isNew ? handleAddAction : undefined}
                                hasRequiredFields={hasRequiredFields}
                                createdClothId={createdClothId}
                            />
                        </div>
                    </div>
                </div>
            </div>

            {showStyleModal && (
                <div className={s.modalOverlay} onClick={() => setShowStyleModal(false)}>
                    <div className={s.modalContent} onClick={(e) => e.stopPropagation()}>
                        <div className={s.modalHandle} />
                        <h3>Выберите стиль</h3>
                        <div className={s.searchContainer}>
                            <div className={s.searchWithButton}>
                                <Form.Control
                                    type="text"
                                    placeholder="Поиск по названию стиля"
                                    value={searchTerm}
                                    onChange={handleSearchChange}
                                    onClick={handleSearchClick}
                                    className={s.searchInput}
                                    autoFocus
                                />
                            </div>
                        </div>

                        <div className={s.stylesListModal}>
                            {filteredStyles.length > 0 ? (
                                filteredStyles.map((style) => (
                                    <div
                                        key={style.id}
                                        className={s.styleItemModal}
                                        onClick={() => addingClothInStyle(style.id)}
                                    >
                                        <span>{style.name}</span>
                                    </div>
                                ))
                            ) : (
                                <div className={s.textEmptyBlock}>
                                    {searchTerm.trim() ? 'Стили не найдены' : 'Нет доступных стилей'}
                                </div>
                            )}
                        </div>
                        <button
                            className={s.modalCloseBtn}
                            onClick={() => {
                                setShowStyleModal(false);
                                setSearchTerm('');
                            }}
                        >
                            Закрыть
                        </button>
                    </div>
                </div>
            )}
        </>
    )
}